import { Alert, CircularProgress, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector } from "react-redux";
import { fonts } from "fonts";
import { useTheme } from "@emotion/react";

export default function ModelSelectorMenu({
  model,
  setModel,
}) {

  const theme = useTheme();
  const modelsState = useSelector((state) => state.collections.models);

  // const model = useSelector((state) => state.imageStudio.model);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectModel = (model) => {
    setModel(model);
    handleClose();
  };

  if(!modelsState) return null;

  if(modelsState.loading) return (
    <CircularProgress size={24} />
  )

  if(modelsState.error) {
    console.log(modelsState.error);
    return (
      <Alert severity="error">Error loading models</Alert>
    );
  }

  const imageModels = modelsState.documents.filter((m) => !m.deprecated && m.type.endsWith("/image"));

  return (
    <Stack
      direction="row"
      alignItems="center"
    >
      <Typography
        fontFamily={fonts.geist}
        sx={{
          color: theme.palette.text.main,
        }}
      >
        {model.label}
      </Typography>
      <IconButton onClick={handleOpen}>
        <ArrowDropDownIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {imageModels.map((m) => {
          return (
          <MenuItem
            key={m.name}
            selected={model.name === m.name}
            onClick={() => handleSelectModel(m)}
          >
            <Stack direction="row" spacing={1}>
              <Typography fontFamily={fonts.geist}>{m.label}</Typography>
            </Stack>
          </MenuItem>
        )})}
      </Menu>
    </Stack>
  );
}
